import * as React from 'react';
import { useField, useForm } from 'react-final-form';
import { SelectFieldGroup } from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { DisabledContext } from '../../../formUtils/DisabledContext';
import { useOrganizationList } from '../../../lib/useOrganizationList';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * the field name of template
 */
const NAME_INPUT = 'name';
const SHARING_INPUT = 'sharingId';
export default function OrganizationSelect() {
  const {
    __
  } = useTranslator();
  const {
    disabled
  } = React.useContext(DisabledContext);
  const {
    mutators
  } = useForm();
  const {
    meta: {
      submitError
    }
    // $FlowFixMe[prop-missing]
  } = useField(NAME_INPUT, {
    subscription: {
      submitError: true
    }
  });
  const {
    input: {
      value
    }
    // $FlowFixMe[prop-missing]
  } = useField(SHARING_INPUT, {
    subscription: {
      value: true
    }
  });
  const {
    organizations,
    isFetching,
    isLoaded
  } = useOrganizationList({
    personalFirst: true
  });
  const orgaOptions = organizations.map(orga => ({
    text: orga.name,
    value: orga.id
  }));
  React.useEffect(() => {
    if (submitError) {
      // In case the name already exists, we clear the error if user selected an other organization
      mutators.clearSubmitError(NAME_INPUT);
    }

    // mutators always change, keep only useful props
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return /*#__PURE__*/_jsx(SelectFieldGroup, {
    name: SHARING_INPUT,
    disabled: disabled,
    label: __('Select the organization'),
    required: true,
    selectProps: {
      // XXX: cheap loading mark, would be better to use react-select (but has problem with redux-form?)
      placeholder: isFetching && !isLoaded ? __('Select …') : __('Select'),
      values: orgaOptions
    }
  });
}
OrganizationSelect.preFetch = useOrganizationList.preFetch;